export default "__VITE_ASSET__CwqCT2os__"